import turflineIntersect from "@turf/line-intersect";

export default function lineIntersect(feature1, feature2) {
    return turflineIntersect(feature1, feature2);
};
